import { useEffect, useRef, useState } from "react";
import BlogAdminDetail from "./PageDetail";
import {
  TabButton,
  TabHeader,
  TabWrapper,
} from "../../../style/admin/Tab_Style";
import Seo from "../Seo";
import { useParams, useNavigate } from "react-router-dom";
import BlogService from "../../../services/api/blog.service";
import { EBlogResponse } from "../../../models/blog";
import { toast } from "../../../utils/notify";
import PageDetail from "./PageDetail";
import {
  Button,
  ModalFooter,
} from "../../../style/admin/BlogCreateModal_Style";
import SeoService from "../../../services/api/seo.service";
import { ESeoResponse } from "../../../models/seo";
import PageService from "../../../services/api/page.service";
import { EPageResponse } from "../../../models/page";
import FaqAdmin from "../FaqAdmin";
import { FaqItem } from "../../../models/faq";
import FaqService from "../../../services/api/faq.service";
import { CountryLanguage } from "../../../i18n/i18n";

const PageDetailPage = () => {
  const [tab, setTab] = useState<"page" | "seo" | "faq">("page");
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [page, setPage] = useState<EPageResponse | null>(null);
  const [seo, setSeo] = useState<ESeoResponse | null>(null);
  const [objId, setObjId] = useState<string | null>(null);
  const [faq, setFaq] = useState<FaqItem[]>([]);

  const blogRef = useRef<any>(null);
  const seoRef = useRef<any>(null);
  const faqRef = useRef<any>(null);

  const handleSave = async () => {
    try {
      const seoValid = await seoRef.current?.validate();
      const blogValid = await blogRef.current?.validate();
      const faqValid = await faqRef.current?.validate();

      if (!seoValid || !blogValid || !faqValid) {
        return;
      }

      await blogRef.current?.submit();
      await seoRef.current?.submit();
      await faqRef.current?.submit();

      toast(id ? "Cập nhật thành công" : "Thêm mới thành công", "success");
    } catch (err) {
      toast("Lỗi khi lưu dữ liệu", "error");
    }
  };

  useEffect(() => {
    if (!id) {
      const newObjId = crypto.randomUUID();
      setObjId(newObjId);
      return;
    }

    const fetchDetail = async () => {
      const res = await PageService.getSingle(id);
      if (res.success) {
        setPage(res.data);
        res.data.id && setObjId(res.data.id);
      } else {
        toast("Không tìm thấy page", "error");
        navigate("/admin/page");
      }

      const resSeo = await SeoService.getSeoByObjId(id);
      if (resSeo.success) {
        setSeo(resSeo.data);
      } else {
        toast("Không tìm thấy seo", "error");
        navigate("/admin/page");
      }

      const resFaq = await FaqService.getSingleByObjId(id);
      if (resFaq.success) {
        setFaq(resFaq.data);
      } else {
        toast("Không tìm thấy faq", "error");
        navigate("/admin/blog");
      }
    };

    fetchDetail();
  }, [id]);
  return (
    <>
      {/* TAB HEADER */}
      <TabHeader>
        <TabButton active={tab === "page"} onClick={() => setTab("page")}>
          📝 Page
        </TabButton>

        <TabButton active={tab === "seo"} onClick={() => setTab("seo")}>
          🔍 SEO
        </TabButton>

        <TabButton
          hidden={page?.name !== "Faq"}
          active={tab === "faq"}
          onClick={() => setTab("faq")}>
          💬 FAQ
        </TabButton>
      </TabHeader>

      <ModalFooter>
        <Button onClick={handleSave} type="submit">
          Lưu
        </Button>
        <Button
          type="button"
          className="cancel"
          onClick={() => navigate("/admin/page")}>
          Đóng
        </Button>
      </ModalFooter>

      {/* TAB CONTENT */}
      <TabWrapper>
        <div style={{ display: tab === "page" ? "block" : "none" }}>
          <PageDetail ref={blogRef} page={page} objId={objId} />
        </div>

        <div style={{ display: tab === "seo" ? "block" : "none" }}>
          <Seo ref={seoRef} seoProp={seo} objId={objId} />
        </div>

        <div style={{ display: tab === "faq" ? "block" : "none" }}>
          <FaqAdmin ref={faqRef} faqItems={faq} objIdProp={objId} />
        </div>
      </TabWrapper>
    </>
  );
};

export default PageDetailPage;
